// Document ready
$(function(){

    /* Neighbourhood Maps Content Archive */

    var $ulNbhMapsContainer = $('#neighbourhood-maps-developments');
    var $colContentContaners = $ulNbhMapsContainer.find('.col-content-container');

    if( $ulNbhMapsContainer.length ) {
        var $devButtons = $ulNbhMapsContainer.find('.list-item button');

        $devButtons.on('click', function() {
            var $contentActiveBtn = $(this); // Active btn
            var $contentActiveItem = $contentActiveBtn.closest('.list-item'); // Active list item
            var mapImg = $contentActiveBtn.data('map-img');
            //var $mapContainer = $ulNbhMapsContainer.find('.map-container');
            //var $mapContainerInner = $mapContainer.find('.map-wrapper');

            // Check first content container visibilityy
            var $colContentContainer = $contentActiveItem.nextAll(".col-content-container:visible").first();
            //var colContentContainerSize = $colContentContainer.data('container-size');

            // If NOT active
            if( !$contentActiveItem.hasClass('is-active') ) {

                // Reset all other Items
                // Remove active states
                $ulNbhMapsContainer.find('.is-active').removeClass('is-active'); // Item active
                // Set Item active states
                $contentActiveItem.addClass('is-active'); // Current item active

                // if col container has content
                if( $colContentContainer.hasClass('has-content') ) {
                    $colContentContainer.addClass('fixed-height');
                    $colContentContainer.find('.map-wrapper img').fadeOut(function(e){
                        $(this).remove();
                        $colContentContainer.find('.map-wrapper').html('<img src="'+mapImg+'" class="map-img img-fuild w-100" style="display:none;">');
                        setTimeout(() => {
                            $colContentContainer.find('.map-wrapper img').fadeIn();
                        }, 100);
                        
                    });

                } else {
                    // Remove active states
                    $colContentContaners.removeClass('has-content fixed-height'); // Col Content Container
                    // Reset END

                    // Set the content
                    $colContentContainer.find('.map-wrapper').html('<img src="'+mapImg+'" class="map-img img-fuild w-100">');
                    setTimeout(() => {
                        $colContentContainer.addClass('has-content');
                    }, 100);
                }
                

                

            }  else {
                // Is active

                // Reset all items
                // Remove active states
                $ulNbhMapsContainer.find('.is-active').removeClass('is-active'); // Remove active state
                // Content Contaners
                $colContentContaners.removeClass('has-content fixed-height');
                // Reset END
            }
        });

    }
});